import Profile, { type ProfileProps } from "./Profile";
export { Profile as default, Profile, ProfileProps };